import styled, {
  StyledComponent,
  isStyledComponent,
  css,
} from 'styled-components';
import Input from 'antd/es/input';

import { SizeUnit } from '@utils/types';
import { InputProps } from '@components/Input/InputProps';

import { widthMixin } from '../mixins';

type InputContainerProps = {
  width?: SizeUnit;
  value?: unknown;
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  InputComponent: StyledComponent<any, any>;
};

const INPUT_SIZE = {
  small: css`
    padding: 8px 12px;
    font-size: 12px;
    line-height: 16px;
  `,
  medium: css`
    padding: 6px 12px;
    font-size: 14px;
    line-height: 24px;
  `,
  large: css`
    padding: 8px 12px;
    font-size: 14px;
    line-height: 24px;
  `,
  xlarge: css`
    padding: 16px 12px;
    font-size: 14px;
    line-height: 24px;
  `,
};

const INPUT_DISABLED = css`
  &&& {
    background-color: ${({ theme }) => theme.palette.grey200};
    border: 1px solid ${({ theme }) => theme.palette.grey200};
    color: ${({ theme }) => theme.palette.grey300};
    cursor: not-allowed;

    &:is(:focus-within, :hover) {
      border: 1px solid ${({ theme }) => theme.palette.grey200};
    }
  }
`;

export const SeturInputStyles = (palette, $size, disabled, hasError) => css`
  color: ${palette.grey1100};
  caret-color: ${palette.black};
  border: 1px solid ${hasError ? palette.errorColor : palette.inputBorderColor};
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.5s ease;
  width: 100%;

  ${INPUT_SIZE[$size || 'large']}

  ${disabled && INPUT_DISABLED}

  &::placeholder {
    color: ${palette.inputPlaceholderColor};
  }

  &:is(:focus-within, :hover) {
    border: 1px solid
      ${hasError ? palette.errorColor : palette.inputBorderColorActive};
  }

  &:focus {
    box-shadow: none;
  }
`;

export const SeturInput = styled(Input)<InputProps>`
  &&& {
    ${({ theme, $size, disabled, hasError }) =>
      SeturInputStyles(theme.palette, $size, disabled, hasError)}
  }
`;

export const InputContainer = styled.div<InputContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  position: relative;
  transition: all 0.5s ease;
  font-family: ${({ theme }) => theme.fonts.main};
  box-sizing: border-box;
  max-width: 100%;

  ${widthMixin};

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export { isStyledComponent, styled };
